import { Component } from "@/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "pill"

export const presets = {}

export interface Props extends Component {}

export function Pill({ children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <div
      className={cx(
        `text-[10px] font-semibold bg-module-gray-fill text-module-gray-text rounded-full h-5 px-2 inline-flex items-center`,
        className,
      )}
      data-test={testId}
    >
      {children}
    </div>
  )
}
